import React, { useCallback } from 'react';
import '../components/Home.css';
import img from '../images/side.png';
import Particles from "react-tsparticles";
import { loadFull } from 'tsparticles';
import Footer from './Footer/Footer';
const Home = () => {

    var TxtRotate = function (el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = "";
        this.tick();
        this.isDeleting = false;
    };

    TxtRotate.prototype.tick = function () {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

        var that = this;
        var delta = 300 - Math.random() * 100;

        if (this.isDeleting) {
            delta /= 2;
        }

        if (!this.isDeleting && this.txt === fullTxt) {
            delta = this.period;
            this.isDeleting = true;
        } else if (this.isDeleting && this.txt === "") {
            this.isDeleting = false;
            this.loopNum++;
            delta = 500;
        }

        setTimeout(function () {
            that.tick();
        }, delta);
    };

    window.onload = function () {
        var elements = document.getElementsByClassName("txt-rotate");
        for (var i = 0; i < elements.length; i++) {
            var toRotate = elements[i].getAttribute("data-rotate");
            var period = elements[i].getAttribute("data-period");
            if (toRotate) {
                new TxtRotate(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #666 }";
        document.body.appendChild(css);
    };

    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
    }, []);


    return (
        <div className='row align-items-center bg-clor bg-img mt-3'>

            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{

                    fpsLimit: 60,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            push: {
                                quantity: 3,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 350,
                            enable: true,
                            opacity: 0.1,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            directions: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 1,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 80,
                        },
                        opacity: {
                            value: 0.5,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                    detectRetina: true,
                }}
            />


            <div className="col-lg-6 col-10 mx-auto col-sm-10 col-md-6">
                <div >

                    <h2 className='text-white' data-aos="fade-right"   >H<span className='text-clor-for-all'>i</span></h2>
                    <hr className='text-white w-25 mx-auto' />
                </div>
                <h5 className='fw-bold text-white'>I am a
    <span className="txt-rotate ms-1" data-period="2000"
                        data-rotate='[ "JR. WEBDEVELOPER", "REACT JS DEVELOPER.", "MERN STACK DEVELOPER" ]'></span>
                </h5>
            </div>
            <div className="col-lg-6 col-10 mx-auto col-sm-10 col-md-6">
                <img className='w-100 img-anime bounce mx-auto' src={img} alt="" />

                <br />

                <>
                    <a className='btn btn-outline-info mx-auto text-white shadow fw-bold mt-2' href='https://drive.google.com/file/d/17KzQJcrj8ix71Mtn3AAyj64kraaoXydr/view?fbclid=IwAR0DnaNCOhq-OFtux2HwXly0-mh__iyupMEGh51yDfXlD04_QY3SeFAaao4'>Resume</a>
                </>

            </div>
            <Footer></Footer>
        </div>
    );
};

export default Home;